import type { TAbstractService } from '@Anarchy/Engine/Abstract';
import { AbstractService } from '@Anarchy/Engine/Abstract';
import type {
  TAnyMaterialWrapper,
  TMaterialConfig,
  TMaterialEntityToConfigDependencies,
  TMaterialFactory,
  TMaterialRegistry,
  TMaterialService,
  TMaterialServiceDependencies,
  TMaterialServiceWithCreate,
  TMaterialServiceWithCreateFromConfig,
  TMaterialServiceWithFactory,
  TMaterialServiceWithRegistry
} from '@Anarchy/Engine/Material/Models';
import type { TDisposable } from '@Anarchy/Engine/Mixins';
import { withCreateFromConfigServiceMixin, withCreateServiceMixin, withFactoryService, withRegistryService, withSerializableEntities } from '@Anarchy/Engine/Mixins';
import { mergeAll } from '@Anarchy/Engine/Utils';
import type { Subscription } from 'rxjs';

export function MaterialService(factory: TMaterialFactory, registry: TMaterialRegistry, dependencies: TMaterialServiceDependencies): TMaterialService {
  const factorySub$: Subscription = factory.entityCreated$.subscribe((wrapper: TAnyMaterialWrapper): void => registry.add(wrapper));
  const disposable: ReadonlyArray<TDisposable> = [registry, factory, factorySub$];
  const abstractService: TAbstractService = AbstractService(disposable);

  const withCreateService: TMaterialServiceWithCreate = withCreateServiceMixin(factory, undefined);
  const withCreateFromConfigService: TMaterialServiceWithCreateFromConfig = withCreateFromConfigServiceMixin(withCreateService.create, factory.configToParams, dependencies);
  const withFactory: TMaterialServiceWithFactory = withFactoryService(factory);
  const withRegistry: TMaterialServiceWithRegistry = withRegistryService(registry);

  return mergeAll(
    abstractService,
    withCreateService,
    withCreateFromConfigService,
    withFactory,
    withRegistry,
    withSerializableEntities<TAnyMaterialWrapper, TMaterialConfig, TMaterialEntityToConfigDependencies>(registry, { textureResourceRegistry: dependencies.textureService.getResourceRegistry() })
  );
}
